import { Injectable, EventEmitter, Type, TemplateRef } from '@angular/core';

@Injectable()
export class TableRenderService {
  private titles: { [key: string]: TemplateRef<void> } = {};
  private rows: { [key: string]: TemplateRef<void> } = {};

  add(type: string, path: string, ref: TemplateRef<void>) {
    this[type === 'title' ? 'titles' : 'rows'][path] = ref;
    this.changeContent(ref);
  }

  getTitle(path: string) {
    return this.titles[path];
  }

  getRow(path: string) {
    return this.rows[path];
  }


 public RenderChangeEvent:EventEmitter<any>;
 constructor() {
   this.RenderChangeEvent=new EventEmitter<any>()
 }
  public changeContent(comp){
     this.RenderChangeEvent.emit(comp)
  }


}
